// 注意：Vue 3 + Vuex 4 不再导入 Vue 构造函数
import { createStore } from 'vuex' // 导入 Vuex 4 的 createStore 方法
import user from "./modules/user"; // 导入 user 模块
import createPersistedState from "vuex-persistedstate";

// Vue 3 + Vuex 4 使用 createStore 创建 store 实例（替代 new Vuex.Store()）
const store = createStore({
  state: {},
  mutations: {},
  actions: {},
  modules: {
    user,
  },
  plugins: [createPersistedState()], // 持久化插件保持不变
});

export default store;